<template>
    <USelectMenu
        v-model="selectedProject"
        :items="projectOptions"
        :ui="ui ?? defaultUi"
        size="sm"
        label-key="name"
        placeholder="Prosjekt"
        create-item
        :default-open="defaultOpen"
        @create="addProject"
    >
        <template v-if="selectedProject" #trailing>
            <UButton
                color="neutral"
                variant="ghost"
                size="sm"
                icon="i-ph-x"
                title="Fjern prosjekt"
                @click.stop="clearProject"
            />
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import {createDimension, Project, useDimensions} from '@/dimensions/dimensions.service'
import {computed} from 'vue'
import {SelectMenuItem} from '@nuxt/ui'

const {projects, newProject} = useDimensions()
const selectedProjectName = defineModel<string>({required: false})

type ProjectOption = Project & SelectMenuItem

const props = defineProps({
    defaultOpen: {type: Boolean, default: false},
    theme: {type: String, default: ''},   //TODO: Type to available theme classes?
    ui: {type: Object, default: undefined}
})

const defaultUi = {
    content: 'z-1 min-w-fit' + props.theme,
    trailing: 'absolute right-0 pr-1'
}

const projectOptions = computed<ProjectOption[]>(() => {
    return projects.value.map(project => project as ProjectOption)
})

const selectedProject = computed<ProjectOption>({
    get: () => {
        return projects.value.find(project => project.name === selectedProjectName.value) as ProjectOption
    },
    set: (value: Project) => {
        selectedProjectName.value = value.name
    }
})

const addProject = (newTagName: string) => {
    const project = newProject(newTagName)
    createDimension(project)
        .then(() => {
            selectedProject.value = project as ProjectOption
        })
}

const clearProject = () => {
    selectedProjectName.value = ''
}
</script>

<style>
</style>